import { SiteEventPlugin } from '@sierralabs/site-ui';

import { QmsEventRoutePlugin } from './QmsEventRoutePlugin';

export const defaultQmsSiteEventPlugins: SiteEventPlugin<any>[] = [
  QmsEventRoutePlugin
];
